import * as Yup from "yup";
import { getNetworkUserTypeId } from "../../../Utils/types";

export const initialFilterState = {
  page: 1,
  rows: 10,
  email: "",
  userRoleId: null,
  mobileNo: null,
  userTypeId: getNetworkUserTypeId(),
  SortColumn: null,
  sortDirection: "Desc",
};

export const YUPValidations = Yup.object().shape({
  userTypeId: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  roleIds: Yup.string(/^[A-Za-z ]*$/)
    .required("Field is required")
    .nullable(),
  providerChainName: Yup.string().when("userTypeId", {
    is: (exists) => {
      return exists == 113;
    },
    then: Yup.string(/^[A-Za-z ]*$/)
      .nullable()
      .required("Field is required")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
      .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
    otherwise: Yup.string().nullable(),
  }),
  firstName: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  lastName: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  mobileNumber: Yup.string()
    .nullable()
    .min(10, "Mobile no must be equal to 10.")
    .max(10, "Mobile no must be equal to 10.")
    .matches(/^\d+$/, "The field should have digits only")
    .required("Field is required"),
  emailId: Yup.string().nullable().email().required("Field is required"),
});
export const tableHeader = [
  {
    name: "Name",
  },
  {
    name: "Email",
  },
  {
    name: "Mobile Number",
  },
  {
    name: "User Type",
  },
  {
    name: "Role",
  },
  {
    name: "Last Updated",
  },
];
export const tableHeaderChain = [
  {
    name: "Name",
  },
  {
    name: "Email",
  },
  {
    name: "Mobile Number",
  },
  {
    name: "User Type",
  },
  {
    name: "Role",
  },
  {
    name: "Chain Name",
  },
  {
    name: "Last Updated",
  },
];
export const TableHeaderAdmin = ({ header, searchFilter, SortHandler }) => {
  return (
    <th scope="col">
      {header}
      <span>
        {searchFilter?.SortColumn !== header ? (
          <img
            className="icon"
            style={{ cursor: "pointer" }}
            onClick={() => SortHandler(header, "asc")}
            src="https://uat.healthassure.in/ProvidersPortal/images/arrowupdown1.png"
            alt="arrowupdown1"
          />
        ) : searchFilter?.sortDirection === "Desc" ? (
          <img
            className="icon"
            style={{ cursor: "pointer" }}
            onClick={() => SortHandler(header, "asc")}
            src="https://uat.healthassure.in/ProvidersPortal/images/down-arrow.png"
            alt="down-arrow"
          />
        ) : (
          searchFilter?.sortDirection === "asc" && (
            <img
              className="icon"
              style={{ cursor: "pointer" }}
              onClick={() => SortHandler(header, "Desc")}
              src="https://uat.healthassure.in/ProvidersPortal/images/up-arrow.png"
              alt="up-arrow"
            />
          )
        )}
      </span>
    </th>
  );
};

export function updateSubMenus(array) {
  for (let i = 0; i < array.length; i++) {
    const menuItem = array[i].menuItem;
    if (array[i].subMenus.length === 0 && menuItem.informationPermissions.length > 0) {
      array[i].subMenus = menuItem.informationPermissions?.map((ele) => {
        return ({
          canEdit: ele?.canEdit,
          canView: ele?.canView,
          title: ele?.informationName,
          networkInformationToMenuMapId: ele?.networkInformationToMenuMapId,
          informationPermissions:[]
        })
      })
    }
  }
  return array;
}